import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  Show,
  SimpleShowLayout,
  TextField,
  useTranslate,
} from 'react-admin';
import { Grid, Typography } from '@mui/material';
import ShowLabel from '../../../components/commons/showLabel';
import ShowActions from '../../../components/commons/showActions';
import FUNC from '../../../utils/functions';
import canAccess from '../../../utils/canAccess';
import StudentsList from '../../../components/master/activityClasses/studentsList';

export default React.memo(() => {
  const { permissions } = useSelector((state: any) => state.app.appState);

  const translate = useTranslate();
  const canEdit = canAccess(permissions, FUNC.EDIT_ACTIVITY_CLASS);
  const canSearch = canAccess(permissions, FUNC.SEARCH_ACTIVITY_CLASSES);
  return (
    <Show
      actions={<ShowActions isEdit={canEdit} isList={canSearch} />}
    >
      <SimpleShowLayout>
        <Grid container spacing={2} rowSpacing={0.5}>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label={translate('resources.master/activity-classes.fields.facultyName')} />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="facultyName"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label={translate('resources.master/activity-classes.fields.courseName')} />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="courseName"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label={translate('resources.master/activity-classes.fields.name')} />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="name"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label={translate('resources.master/activity-classes.fields.studentQuantity')} />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="studentQuantity"
            />
          </Grid>
          <Grid container xs={12} md={12} mt={3} mx={1}>
            <Typography variant="h6" sx={{ marginLeft: 1 }}>
              {translate('resources.master/activity-classes.fields.students')}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <StudentsList />
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
});
